module.exports = __webpack_public_path__ + "static/media/launch_boatyard_marker.252e0a23.svg";